module.exports = __webpack_public_path__ + "img/ioniq-9.f069bee8.png";